/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { success, error } from '@/libs/notification';
import router from '@/router';
import {
  CompanyGroupsState,
  CompanyGroupsDataState,
  CompanyGroupReplaceData,
  CompanyGroupsSubmitData
} from '@/types/master/companyGroup';

import { ElLoading } from 'element-plus';
import { handleAuthorizationError } from '@/libs/apiErrorHandler';
import { getAccessToken } from '@/libs/firebaseAuth';
import { getBaseUrl } from '@/libs/env';

export default {
  namespaced: true,
  state: {
    listData: [],
    replaceData: null
  },
  mutations: {
    setCompanyGroups(
      state: CompanyGroupsState,
      payload: CompanyGroupsDataState[]
    ) {
      state.listData = payload;
    },
    setReplace(state: CompanyGroupsState, payload: CompanyGroupReplaceData) {
      state.replaceData = payload;
    }
  },
  actions: {
    async fetch(context: any) {
      await axios
        .get(getBaseUrl() + '/master/company-groups', {
          headers: { auth: await getAccessToken() }
        })
        .then((response) => {
          context.commit('setCompanyGroups', response.data);
          const replaceData: CompanyGroupReplaceData = {};
          response.data.forEach((data: CompanyGroupsDataState) => {
            replaceData[data.id] = {
              name: data.name,
              fcCode: data.fcCode,
              companyGroupType: data.companyGroupType
            };
          });
          context.commit('setReplace', replaceData);
        })
        .catch(async (e) => {
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status < 500) {
            error(e.response.status);
            router.push('/top');
          } else {
            router.push('/error/server');
          }
        });
    },
    async submit(context: any, payload: CompanyGroupsSubmitData) {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      await axios
        .post(getBaseUrl() + '/master/company-groups', payload, {
          headers: { auth: await getAccessToken() }
        })
        .then(() => {
          success('Success', '販売店グループ登録に成功しました。');
          router.push('/master/companygroup');
        })
        .catch(async (e) => {
          loadingInstance.close();
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status < 500) {
            error(e.response.status);
          } else {
            router.push('/error/server');
          }
        });
    }
  }
};
